import { useIsLargeUp } from '@components/responsive/render_large_up'

const RenderSmallDown = ({ children }) => {
  const isLargeUp = useIsLargeUp()

  return !isLargeUp ? children : null
}

export default RenderSmallDown
